import { useEffect, useRef } from "react";
import { FaPlay } from "react-icons/fa";

/**
 * Video Side
 * 
 * Video side is used in Home page. To show different
 * videos on page.
 *
 * @param {string} videoDisplay Path to video which should be played
 * @param {Function} showInfoVideo Callback function that starts the promo video
 * 
 * @returns html5 video
 */
const VideoSide = ({videoDisplay, showInfoVideo}) => {

    const videoRef = useRef(); // video ref

    // when videoDisplay is avaible set mute/controlls depending on video
    useEffect(() => {
        videoRef.current.load(null);
        videoRef.current.focus();
        if (videoDisplay.includes('noQrPromo')) {
            videoRef.current.muted = false;
            videoRef.current.play();
        }
    }, [videoDisplay])

    // GUI
    return (
        <>
            {videoDisplay.includes('hero') &&
                <div className="video-btn-section">
                    <button 
                        className="btn-energo video-btn" 
                        onClick={() => showInfoVideo()}
                    >
                        <FaPlay />
                    </button>
                </div>
            }
            <video
                className="video-section"
                id="background-video"
                autoPlay={videoDisplay.includes('hero')}
                muted={videoDisplay.includes('hero')}
                controls={!videoDisplay.includes('hero')}
                ref={videoRef}
                playsInline
            >
                <source src={videoDisplay} type="video/mp4" />
            </video>
        </>
    )
}
export default VideoSide;